import {
  SetSecurePayCardDetailsFlow,
  SetCallVariableFlow,
  LaunchSecurePayFlow,
  OpenBridgeFlow
} from './five9';

import{
  Five9Client
} from './five9/client';

import { authToken } from '@td/api';


/*
 *  Example Call:
 *   launchSecurePay(1,{first_nm: 'foo', last_nm: 'bar', address1: '123 main st', address2: '', city: 'Dallas', state: 'TX', zip: '75238'}, () => console.log('done'))
 *
*/
const launchSecurePay = (memberId, ccInfo, onStatusUpdate, onClose) => {

  const five9Client = new Five9Client();
  const apiHost = "";

  return OpenBridgeFlow(onStatusUpdate, onClose).then( (bridgeUrl) => {
    const preSetCallVariables = [
      SetSecurePayCardDetailsFlow({BridgeURL: bridgeUrl, ClientUniqueID: memberId, ...ccInfo}, five9Client),
      SetCallVariableFlow("TeladocAPI", "AuthToken", authToken.get(), five9Client),
      SetCallVariableFlow("TeladocAPI", "GatewayURL", apiHost, five9Client),
    ]
    return Promise.all(preSetCallVariables)
  })
  .then( () => LaunchSecurePayFlow(five9Client, onClose) )
  .then( () => onStatusUpdate('zMember In Secure Pay') )
}


window.launchSecurePay = launchSecurePay;
export default launchSecurePay;
